var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isHidden)?_c('div',[_c('vs-checkbox',{staticClass:"mb-4 mt-5",attrs:{"disabled":_vm.disabled,"value":_vm.value},on:{"change":function($event){return _vm.$emit('input',$event.target.checked)}}},[_vm._v(_vm._s(_vm.label))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }